import { Dialog } from "@mui/material";
import { useState } from "react";
import { EditPpsAndValuation } from "../modals/EditPpsAndValuation";
import { useCanUserAccess } from "../store/useRoleGrantStore";
import { useIsInternalUser } from "../queries/userProfile";
import { useGetCompanyDetails } from "../queries/termsheet";
import { ButtonSize, SecondaryCTAButton } from "../pages/quickRound/CTAButtonComponents";

type Props = {
  eventId: string;
  pps?: number;
  valuation?: number;
  paymentType?: string | null;
  issuanceType?: string | null;
  authorizedEquity?: number | null;
  authorizedPreference?: number | null;
  isReadOnly?: boolean;
};

export function InternalValuationAction({ isReadOnly = false, ...props }: Props) {
  const [open, setOpen] = useState(false);
  const { isInternalUser } = useIsInternalUser();
  const { data: companyDetails } = useGetCompanyDetails();
  const canUpdate = useCanUserAccess("update", "captable");
  const canCreateTransactions = useCanUserAccess("create", "transaction");

  if (
    isReadOnly ||
    !isInternalUser ||
    !canUpdate ||
    !canCreateTransactions ||
    !props.eventId
  )
    return null;

  return <>
    <SecondaryCTAButton buttonSize={ButtonSize.SMALL} onClick={() => setOpen(true)}>
      Update Valuation & PPS
    </SecondaryCTAButton>
    <Dialog open={open} maxWidth="md" onClose={() => setOpen(false)}>
      <EditPpsAndValuation
        {...props}
        paymentType={props.paymentType ?? null}
        issuanceType={props.issuanceType ?? null}
        pps={props.pps ?? companyDetails?.capitalDetails?.pps ?? 0}
        valuation={props.valuation ?? companyDetails?.capitalDetails?.valuation ?? 0}
        onSecondaryAction={() => setOpen(false)}
      />
    </Dialog>
  </>;
}
